import { getFeatures } from 'context/Feature'
import { MenuOptions } from './TopBar.types'

export const ENABLED_MENU_OPTIONS: MenuOptions[] = [
  getFeatures().hasGalleries && MenuOptions.GALLERIES,
  MenuOptions.FAQ,
].filter(Boolean) as MenuOptions[]
